import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  private baseUrl = environment.countryBaseUrl + environment.countryUrl;

  constructor(private http: HttpClient) { }

  getByCountryCode(countryCode: any): Observable<any> {
    return this.http.get(`${this.baseUrl}countries/by-country-code/${countryCode}`);
  }

  getCountries(): Observable<any> {
    return this.http.get(`${this.baseUrl}countries`);
  }

  getStatesByCountryCode(countryCode: any): Observable<any> {
    return this.http.get(`${this.baseUrl}states/by-country-code?countryName=${countryCode}`);
  }

  getLocalGovernmentsByStateCode(stateCode: any): Observable<any> {
    return this.http.get(`${this.baseUrl}local-governments?stateCode=${stateCode}`);
  }
}